import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=65604cf0"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports